/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {

  // Make left product column match right column height so sticky image has room to scroll
  function matchProductColumnHeights() {
    const left = document.querySelector('[data-product-single-media-group]');
    if (!left) return;
    const right = left.nextElementSibling;
    if (!right) return;
    if (window.innerWidth >= 1024) {
      left.style.minHeight = right.offsetHeight + 'px';
    } else {
      left.style.minHeight = '';
    }
  }

  // Wrap the sticky media layout (image + existing thumb strip) together
  function wrapStickyMedia() {
    if (window.innerWidth < 1024) return;
    const mediaGroup = document.querySelector('[data-product-single-media-group]');
    if (!mediaGroup || mediaGroup.querySelector('.sr-sticky-media-wrapper')) return;

    const swiper = mediaGroup.querySelector('.product-media.swiper-container');
    const nav = mediaGroup.querySelector('.tw-relative');
    if (!swiper) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'sr-sticky-media-wrapper';
    swiper.parentNode.insertBefore(wrapper, swiper);
    wrapper.appendChild(swiper);
    if (nav) wrapper.appendChild(nav);
  }

  // Build a vertical thumbnail strip on the left of the main image (desktop only)
  // Reads thumbnail images from the existing horizontal strip so we don't touch Liquid
  function buildVerticalThumbs() {
    if (window.innerWidth < 1024) return;
    const mediaGroup = document.querySelector('[data-product-single-media-group]');
    if (!mediaGroup) return;
    if (mediaGroup.querySelector('.sr-thumb-col')) return; // already built

    // Source thumb data from the existing horizontal nav items
    const existingNavItems = mediaGroup.querySelectorAll('.product-media-nav-item[data-slide-index]');
    if (existingNavItems.length < 2) return; // single image or no nav, skip

    // Build the vertical column with up/down arrow buttons
    const col = document.createElement('div');
    col.className = 'sr-thumb-col';

    const btnUp = document.createElement('button');
    btnUp.className = 'sr-thumb-arrow sr-thumb-arrow--up';
    btnUp.innerHTML = '&#8679;';
    btnUp.setAttribute('aria-label', 'Scroll thumbnails up');
    col.appendChild(btnUp);

    const scrollWrap = document.createElement('div');
    scrollWrap.className = 'sr-thumb-scroll';
    col.appendChild(scrollWrap);

    const btnDown = document.createElement('button');
    btnDown.className = 'sr-thumb-arrow sr-thumb-arrow--down';
    btnDown.innerHTML = '&#8681;';
    btnDown.setAttribute('aria-label', 'Scroll thumbnails down');
    col.appendChild(btnDown);

    existingNavItems.forEach((item, i) => {
      const img = item.querySelector('img');
      if (!img) return;
      const btn = document.createElement('button');
      btn.className = 'sr-thumb-item' + (i === 0 ? ' active' : '');
      btn.dataset.slideIndex = i;
      const thumbImg = document.createElement('img');
      thumbImg.src = img.src && !img.src.endsWith('undefined') ? img.src : (img.dataset.src || '');
      thumbImg.alt = img.alt || '';
      btn.appendChild(thumbImg);
      scrollWrap.appendChild(btn);
    });

    // Insert the vertical col before the sticky wrapper (or before the swiper)
    const wrapper = mediaGroup.querySelector('.sr-sticky-media-wrapper') || mediaGroup.querySelector('.product-media.swiper-container');
    if (wrapper) {
      mediaGroup.insertBefore(col, wrapper);
    }

    // Arrow scroll
    const SCROLL_AMOUNT = 78;
    btnUp.addEventListener('click', () => { scrollWrap.scrollBy({ top: -SCROLL_AMOUNT, behavior: 'smooth' }); });
    btnDown.addEventListener('click', () => { scrollWrap.scrollBy({ top: SCROLL_AMOUNT, behavior: 'smooth' }); });

    // Show/hide arrows based on scroll position
    function updateArrows() {
      const atTop = scrollWrap.scrollTop <= 0;
      const atBottom = scrollWrap.scrollTop + scrollWrap.clientHeight >= scrollWrap.scrollHeight - 2;
      btnUp.style.opacity = atTop ? '0.25' : '1';
      btnUp.style.pointerEvents = atTop ? 'none' : 'auto';
      btnDown.style.opacity = atBottom ? '0.25' : '1';
      btnDown.style.pointerEvents = atBottom ? 'none' : 'auto';
    }
    scrollWrap.addEventListener('scroll', updateArrows);

    // Match thumb scroll area max-height to swiper height
    function syncThumbHeight() {
      const swiperEl = mediaGroup.querySelector('.product-media.swiper-container');
      if (swiperEl) {
        const arrowH = btnUp.offsetHeight + btnDown.offsetHeight + 16; // 16px gap
        scrollWrap.style.maxHeight = (swiperEl.offsetHeight - arrowH) + 'px';
        updateArrows();
      }
    }
    syncThumbHeight();
    window.addEventListener('resize', syncThumbHeight);

    // Wire up clicks
    const thumbBtns = scrollWrap.querySelectorAll('.sr-thumb-item');
    const swiperEl = mediaGroup.querySelector('.product-media.swiper-container');

    thumbBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.slideIndex, 10);
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.slideTo(idx);
        }
        thumbBtns.forEach(t => t.classList.remove('active'));
        btn.classList.add('active');
      });
    });

    // Keep active state in sync when Swiper changes slide
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.on('slideChange', () => {
        const idx = swiperEl.swiper.realIndex;
        thumbBtns.forEach((t, i) => t.classList.toggle('active', i === idx));
        // Scroll active thumb into view
        const activeBtn = scrollWrap.querySelector('.sr-thumb-item.active');
        if (activeBtn) activeBtn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        updateArrows();
      });
    }

    // Hide the original horizontal nav on desktop now that we have vertical
    const horizNav = mediaGroup.querySelector('.tw-relative');
    if (horizNav) horizNav.classList.add('d-lg-none');

    // Add layout class to media group for CSS flex
    mediaGroup.classList.add('sr-media-layout-active');

    updateArrows();
  }

  window.addEventListener('load', () => {
    wrapStickyMedia();
    buildVerticalThumbs();
    matchProductColumnHeights();
  });

  window.addEventListener('resize', () => {
    matchProductColumnHeights();
  });

});

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */

/* SR Mobile Nav Drawer */
(function() {
  function initDrawer() {
    var closeBtn = document.getElementById('srDrawerClose');
    var drawer = document.getElementById('srNavDrawer');
    var overlay = document.getElementById('srNavOverlay');

    if (!drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add('open');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Event delegation — any .sr-drawer-open button anywhere on the page
    document.addEventListener('click', function(e) {
      if (e.target.closest('.sr-drawer-open')) openDrawer();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Submenus
    var toggles = drawer.querySelectorAll('.sr-drawer-toggle');
    toggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        var submenu = this.parentElement.querySelector('.sr-drawer-submenu');
        this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (submenu) submenu.classList.toggle('open', !isOpen);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }
})();


/* SR Pill Header */
(function() {
  function initPillHeader() {
    var pill = document.getElementById('srPillHeader');
    var searchToggle = document.getElementById('srPillSearchToggle');
    var searchClose = document.getElementById('srPillSearchClose');
    var searchInput = document.getElementById('srPillSearchInput');
    var scrollThreshold = 80;

    if (!pill) return;

    // Show/hide on scroll
    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var currentScroll = window.pageYOffset;
      if (currentScroll > scrollThreshold) {
        pill.classList.add('sr-pill-visible');
      } else {
        pill.classList.remove('sr-pill-visible');
        // Close search when scrolled back to top
        pill.classList.remove('sr-pill-search-open');
      }
      lastScroll = currentScroll;
    }, { passive: true });

    // Search toggle
    if (searchToggle) {
      searchToggle.addEventListener('click', function() {
        pill.classList.add('sr-pill-search-open');
        setTimeout(function() {
          if (searchInput) searchInput.focus();
        }, 50);
      });
    }

    // Search close
    if (searchClose) {
      searchClose.addEventListener('click', function() {
        pill.classList.remove('sr-pill-search-open');
        if (searchInput) searchInput.value = '';
      });
    }
    // Mobile header search button triggers pill search directly
    var mobileSearchToggle = document.getElementById('srMobileSearchToggle');
    if (mobileSearchToggle) {
      mobileSearchToggle.addEventListener('click', function() {
        var pill = document.getElementById('srPillHeader');
        var pillSearchToggle = document.getElementById('srPillSearchToggle');
        if (pill && pillSearchToggle) {
          pill.classList.add('sr-pill-visible');
          pillSearchToggle.click();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPillHeader);
  } else {
    initPillHeader();
  }
})();
